

import Icon from "../../../../components/AppIcon";

const OverviewTab = ({ order, formatCurrency }) => (
  <div className="space-y-4">
    {/* Order Summary Card */}
    <div className="bg-white border border-gray-200 p-4 rounded-lg">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-900">Order Summary</h3>
        <span className="text-xs text-gray-500">ID: #{order.orderNumber}</span>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {[
          { 
            label: 'Tracking ID', 
            value: order.trackingId || '—',
            icon: 'Hash' 
          },
          { 
            label: 'Type', 
            value: order.testType || 'Package',
            icon: 'FileText' 
          },
          { 
            label: 'Collection', 
            value: order.isHomeSample ? 'Home' : 'Center',
            icon: 'Home' 
          },
          { 
            label: 'Date', 
            value: new Date(order.date).toLocaleDateString('en-IN'),
            icon: 'Calendar' 
          },
          { 
            label: 'Time Slot', 
            value: order.slot || 'Flexible',
            icon: 'Clock' 
          },
          {
            label: 'Priority',
            value: order.isUrgent ? 'Urgent' : 'Standard',
            icon: 'AlertCircle',
            color: order.isUrgent ? 'text-red-600' : 'text-gray-600'
          },
          ...(order.sampleCollectedAt ? [{
            label: 'Sample Collected At',
            value: new Date(order.sampleCollectedAt).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }),
            icon: 'CheckCircle',
            color: 'text-green-600'
          }] : []),
        ].map((item, i) => (
          <div key={i} className="bg-gray-50/50 hover:bg-gray-50 transition-colors border border-gray-100 rounded-md p-3">
            <div className="flex items-center gap-2 mb-1.5">
              <Icon name={item.icon} size={12} className={`text-gray-400 ${item.color || ''}`} />
              <p className="text-xs text-gray-500 font-medium">{item.label}</p>
            </div>
            <p className={`text-sm font-semibold truncate ${item.color || 'text-gray-900'}`}>
              {item.value}
            </p>
          </div>
        ))}
      </div>

      {/* Financial Summary */}
      <div className="mt-4 pt-4 border-t border-gray-100">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-xs text-gray-500">Subtotal</p>
            <p className="text-xs text-gray-500">Discount</p>
            <p className="text-xs text-gray-500">Tax</p>
          </div>
          <div className="space-y-1 text-right">
            <p className="text-xs font-medium text-gray-900">
              {formatCurrency(order.totalAmount)}
            </p>
            <p className="text-xs font-medium text-green-600">
              - {formatCurrency(order.discount || 0)}
            </p>
            <p className="text-xs font-medium text-gray-900">
              + {formatCurrency(order.taxAmount || 0)}
            </p>
          </div>
        </div>
        
        <div className="mt-3 pt-3 border-t border-gray-200 flex justify-between items-center">
          <div>
            <span className="text-xs font-medium text-gray-700">Total Amount</span>
            {order.paymentMethod && (
              <p className="text-xs text-gray-500 mt-0.5">
                Paid via {order.paymentMethod}
              </p>
            )}
          </div>
          <span className="text-xl font-bold text-blue-600">
            {formatCurrency(order.finalAmount || 0)}
          </span>
        </div>
      </div>
    </div>

    {/* Address & Notes Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Address Card */}
      {order.address && (
        <div className="bg-white border border-gray-200 p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="MapPin" size={14} className="text-gray-400" />
            <h3 className="text-sm font-semibold text-gray-900">Delivery Address</h3>
          </div>
          <div className="space-y-1.5">
            <p className="text-xs font-medium text-gray-900">{order.address.recipientName || 'N/A'}</p>
            <p className="text-xs text-gray-600 leading-relaxed">
              {order.address.streetAddress || order.address.landmark}
              {order.address.landmark && (
                <span className="block text-gray-500 text-[11px] mt-0.5">
                  Landmark: {order.address.landmark}
                </span>
              )}
            </p>
            <p className="text-xs text-gray-600">
              {order.address.city}, {order.address.state} - {order.address.pincode}
            </p>
            {order.address.contactNumber && (
              <p className="text-xs text-gray-600 mt-2">
                <span className="font-medium">Contact:</span> {order.address.contactNumber}
              </p>
            )}
          </div>
        </div>
      )}

      {/* Notes Card */}
      {(order.notes || order.specialInstructions) && (
        <div className="bg-white border border-gray-200 p-4 rounded-lg">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="FileText" size={14} className="text-gray-400" />
            <h3 className="text-sm font-semibold text-gray-900">Order Notes</h3>
          </div>
          <div className="space-y-2">
            {order.notes && (
              <div>
                <p className="text-xs text-gray-500 mb-1">General Notes</p>
                <p className="text-xs text-gray-700 bg-gray-50 p-2 rounded border border-gray-100">
                  {order.notes}
                </p>
              </div>
            )}
            {order.specialInstructions && (
              <div>
                <p className="text-xs text-gray-500 mb-1">Special Instructions</p>
                <p className="text-xs text-gray-700 bg-amber-50 p-2 rounded border border-amber-100">
                  {order.specialInstructions}
                </p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>

 
    
  </div>
);

export default OverviewTab;